import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { getAttendeesForCurrentRound } from "../data/httpClient";

export const NotCheckedInAttendeesPage = () => {
  const [notCheckedInAttendees, setNotCheckedInAttendees] = useState<any[]>([]);
  const { roundId, tournamentId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAttendees = async () => {
      if (roundId !== undefined) {
        const roundIdNum = parseInt(roundId, 10);
        const attendees =
          (await getAttendeesForCurrentRound?.(roundIdNum)) ?? [];
        const notCheckedIn = attendees.filter(
          (a: { checkedIn: boolean }) => !a.checkedIn
        );
        setNotCheckedInAttendees(notCheckedIn);
      }
    };
    fetchAttendees();
  }, [roundId]);

  return (
    <div className="checkinPageWrapper">
      <div className="topOptionsContainer">
        <button
          className="greyBtn"
          onClick={() => {
            navigate(`/tournaments/${tournamentId}/admin/check-in`);
          }}
        >
          Back to Check In
        </button>
      </div>
      <h2 style={{ marginTop: "2rem" }}>Not Checked In Attendees</h2>
      <table className="attendeeTable">
        <thead>
          <tr>
            <th>Attendee</th>
          </tr>
        </thead>
        <tbody>
          {!notCheckedInAttendees.length ? (
            <tr>
              <td>No attendees found</td>
            </tr>
          ) : (
            notCheckedInAttendees.map((att, idx) => (
              <tr key={att.id ?? idx}>
                <td className="truncateText">
                  {att.user?.nameFirst} {att.user?.nameLast}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
